export default function(template, parentLocation, dependencyPath) {
  return `
<!-- ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓   start of template   ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ ↓ -->
${template}
<!-- ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑   end of template   ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ ↑ -->

<link rel="stylesheet" type="text/css" href="${dependencyPath}/css/document.css">

<script>
  window.PARENT_HOST = '${parentLocation}';
</script>
<script src="${dependencyPath}/js/document.js"></script>
`;
}
